import config from '@app/config';

export const defaultDataNews = {
  'novosti-kompanii': [
    {
      title: 'Поздравляем с наступающим Новым 2023 годом и Рождеством!',
      code: 'pozdravlyaem-s-nastupayuschim-novyim-2023-godom-i-rojdestvom',
      image: `${config.baseImageUrl}/themes/tireshop2/images/news/876-7b9ce29e04cf721780f52de0139c9cfc.jpg`,
      type: 'novosti-kompanii',
      description: 'Новости компании, анонсы',
    },
    {
      title: 'Обновленный центр Колесо.ру в Стерлитамаке',
      code: 'obnovlennyiy-tsentr-koleso-ru-v-sterlitamake',
      image: `${config.baseImageUrl}/themes/tireshop2/images/news/875-877b9cf05acb991ff7c4d5ec0b3a98fc.jpg`,
      type: 'novosti-kompanii',
      description: 'Новости компании, анонсы',
    },
  ],
  stati: [
    {
      title: 'Топ летних шин',
      code: 'top-letnih-shin',
      image: `${config.baseImageUrl}/articles/wp-content/uploads/2023/02/Обложка-2.jpg`,
      type: 'stati',
      description: 'Статья',
    },
    {
      title: 'Лучшие китайские шины: обзор и рейтинг',
      code: 'top-kitayskih-shin',
      image: `${config.baseImageUrl}/articles/wp-content/uploads/2022/12/Обложка.jpg`,
      type: 'stati',
      description: 'Статья',
    },
  ],
};
